import { RocketIcon } from '@radix-ui/react-icons';
import { Box, Callout, CodeBlock, CopyButton, Flex } from '@workos-inc/design-system';
export const WorkOSCliCallout = () => <Callout.Root color="blue" my="5" style={{
  display: 'block'
}} data-sentry-element="Callout.Root" data-sentry-component="WorkOSCliCallout" data-sentry-source-file="workos-cli-callout.tsx">
    <Flex align="start" gap="2" mb="3" data-sentry-element="Flex" data-sentry-source-file="workos-cli-callout.tsx">
      <Callout.Icon data-sentry-element="Callout.Icon" data-sentry-source-file="workos-cli-callout.tsx">
        <RocketIcon data-sentry-element="RocketIcon" data-sentry-source-file="workos-cli-callout.tsx" />
      </Callout.Icon>
      <Callout.Text data-sentry-element="Callout.Text" data-sentry-source-file="workos-cli-callout.tsx">
        Quickly integrate AuthKit in your project with the AI-powered WorkOS
        CLI.
      </Callout.Text>
    </Flex>
    <Box style={{
    width: 'fit-content'
  }} data-sentry-element="Box" data-sentry-source-file="workos-cli-callout.tsx">
      <CodeBlock.Root data-sentry-element="CodeBlock.Root" data-sentry-source-file="workos-cli-callout.tsx">
        <CodeBlock.Content data-sentry-element="CodeBlock.Content" data-sentry-source-file="workos-cli-callout.tsx">
          <Flex align="center" gap="4" data-sentry-element="Flex" data-sentry-source-file="workos-cli-callout.tsx">
            <CodeBlock.LineGroup gutter="cli" data-sentry-element="CodeBlock.LineGroup" data-sentry-source-file="workos-cli-callout.tsx">
              <CodeBlock.Line data-sentry-element="CodeBlock.Line" data-sentry-source-file="workos-cli-callout.tsx">npx workos@latest</CodeBlock.Line>
            </CodeBlock.LineGroup>
            <Box pr="2" data-sentry-element="Box" data-sentry-source-file="workos-cli-callout.tsx">
              <CopyButton onClick={() => navigator.clipboard.writeText('npx workos@latest')} data-sentry-element="CopyButton" data-sentry-source-file="workos-cli-callout.tsx" />
            </Box>
          </Flex>
        </CodeBlock.Content>
      </CodeBlock.Root>
    </Box>
  </Callout.Root>;